import "shared/initializers/polyfills.js";
import "external/initializers/context_external.js";
import Config from "shared/config.js";
import Calendar from "shared/models/calendar.js";
import MiniSuggester from "patient/components/calendars/show/mini_suggester.js";
import SuggestionStateProvider from "shared/components/suggesters/suggestion_state_provider.js";
import SuggestionProvider from "shared/components/suggesters/suggestion_provider.js";
import ReactDOM from "react-dom";
import moment from "moment";
import PI from "services/progenda_interface.js";

window.moment = moment;
window.I18n = I18n;

$.ajaxSetup({
  dataType: "json",
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
});

$.ajaxPrefilter(function(options, originalOptions, jqXHR) {
  options.data = $.param(
    $.extend(originalOptions.data, { locale: I18n.get().locale })
  );
});

$(function() {
  I18n.setScope("patient");
  AppRoutes.configure({prefix: Config.get().host});
  PI.initialize(AppRoutes);

  $(".progenda-suggester").each(function() {
    var slug = $(this).data("calendar-slug");
    Calendar.retrieve(slug).then(calendar => {
      ReactDOM.render(
        <SuggestionStateProvider selectedCalendars={[calendar]}>
          <SuggestionProvider splitType="PREVIEW_FULL" utmMedium="embedded">
            <MiniSuggester />
          </SuggestionProvider>
        </SuggestionStateProvider>,
        $(this).get(0)
      );
    });
  });
});
